<template>
    <div class="c-event-typeahead__wrapper">
        <div class="c-event-filters__search-wrap">
            <label class="u-hidden-visually" for="find-event">Find an event</label>
            <span class="c-event-filters__search-icon far fa-search" aria-hidden="true"></span>
            <input type="search" id= "find-event" name="find-event" class="c-event-filters__search-input" v-model="input" placeholder="Find an event..."/>
        </div>
        <div class="c-event-typeahead__items" v-if="input.length > 2 && showResults">
            <div class="c-event-typeahead__item" v-for="(item, index) in filteredEvents" :key="index"
                 v-html="item.html">
            </div>
            <div class="c-event-typeahead__item" v-if="input && !filteredCount">
                <p class="c-event-typeahead__item-no-results">No results found for '{{ input }}'</p>
            </div>
            <a :href="whatsOnLink" class="c-cta">
                {{ filteredCount ? 'View More' : "View All Events" }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Typeahead",
        props: ['searchTerm', 'showResults'],
        data() {
            return {
                input: this.searchTerm ?? '',
                events: window.typehead.events,
            }
        },
        methods: {
            textEvalute(title, input) {
                let normalizeTitle = title.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
                let normalizeInput = input.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
                return normalizeTitle.includes(normalizeInput)
            }
        },  
        computed: {
            // Filters events with input and return first 4
            filteredEvents() {
                let filtered = [];

                Object.values(this.events).forEach((item) => {
                    if (this.textEvalute(item.name, this.input)) {
                        filtered.push(item);
                    }
                })

                // First four only
                return filtered.slice(0, 4);
            },
            // Retrieve the number of filter events
            filteredCount() {
                return Object.keys(this.filteredEvents).length
            },
            // Returns a URL to the whats on
            whatsOnLink() {
                if(this.filteredCount) {
                    return window.location.origin + "/events-and-tickets?search=" + this.input
                } else {
                    return window.location.origin + "/events-and-tickets"
                }
            }
        }
    }
</script>

<style scoped>

</style>
